import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import HomePage from "@/pages/HomePage";
import ConsultationsPage from "@/pages/ConsultationsPage";
import ProcessPage from "@/pages/ProcessPage";
import VerifyPage from "@/pages/VerifyPage";
import ContactPage from "@/pages/ContactPage";
import AstrologyPage from "@/pages/AstrologyPage";
import NumerologyPage from "@/pages/NumerologyPage";
import VastuPage from "@/pages/VastuPage";
import AstrocartographyPage from "@/pages/AstrocartographyPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/consultations" element={<ConsultationsPage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/services/vedic-astrology" element={<AstrologyPage />} />
          <Route path="/services/numerology" element={<NumerologyPage />} />
          <Route path="/services/vastu" element={<VastuPage />} />
          <Route path="/services/astrocartography" element={<AstrocartographyPage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
